import React, { useState } from "react"
import Back from "../common/back/Back"
import { faq } from "../../dummydata"
import "./price.css"

const Pricing = () => {
  const [open, setOpen] = useState(null)

  return (
    <>
      <Back title="FAQ" />

      <section className="faq-page padding">
        <div className="container">

          <div className="faq-intro">
            <p className="faq-eyebrow">GOT QUESTIONS?</p>
            <h2>Frequently Asked Questions</h2>
            <p>Everything you need to know about our programmes, pricing, and enrollment process.</p>
          </div>

          <div className="faq-list">
            {faq.map((item, i) => (
              <div
                key={i}
                className={`faq-item ${open === i ? "open" : ""}`}
              >
                <button
                  className="faq-question"
                  onClick={() => setOpen(open === i ? null : i)}
                  aria-expanded={open === i}
                >
                  <span>{item.title}</span>
                  <div className="faq-icon">
                    <i className={`fa fa-${open === i ? "minus" : "plus"}`}></i>
                  </div>
                </button>
                {open === i && (
                  <div className="faq-answer">
                    <p>{item.desc}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Still have questions strip */}
          <div className="faq-contact-strip">
            <div className="faq-contact-icon">
              <i className="fa fa-comment-dots"></i>
            </div>
            <div>
              <h3>Still have questions?</h3>
              <p>Can't find what you're looking for? Chat with us directly.</p>
            </div>
            <div className="faq-contact-btns">
              <a
                href="https://wa.me/254722525826"
                target="_blank"
                rel="noreferrer"
                className="faq-wa-btn"
              >
                <i className="fab fa-whatsapp"></i> WhatsApp Us
              </a>
              <a href="/contact" className="faq-contact-btn">
                <i className="fa fa-envelope"></i> Send Enquiry
              </a>
            </div>
          </div>

        </div>
      </section>
    </>
  )
}

export default Pricing
